import type { ReactNode } from 'react'
import { StorefrontBackdrop } from '../storefront/chrome'

/**
 * Public pages layout — bare container, no chrome.
 *
 * Per Kiran 2026-05-15: the Navbar is signed-in chrome only. Public
 * pages (HomePage, NotFoundPage) own their own header / branding /
 * auth CTAs.
 *
 * The background image is single-sourced from
 * `store.config.ts.brand.heroImagePath` (Kiran 2026-05-21: same image
 * across pages, changed in one place) and rendered fixed behind the page.
 */
export function MainLayout({
  children,
  drift = false
}: {
  readonly children: ReactNode
  /** Home route only: slow Ken-Burns drift on the background image. */
  readonly drift?: boolean
}): JSX.Element {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-bg-primary">
      <div className="fixed inset-0 z-0">
        <StorefrontBackdrop drift={drift} />
      </div>
      <div className="relative z-10">{children}</div>
    </div>
  )
}
